import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { datePickerMinDate, isSCCase } from '../../shared/constants';
import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-company-appt-list',
	templateUrl: './company-appt-list.component.html',
	styleUrl: './company-appt-list.component.scss'
})
export class CompanyApptListComponent implements OnInit, OnDestroy, AfterViewInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/comp/list-appointment",
			name: "Appointment List"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dtOptions: Config = {};
	dataList: any = [];
	showDeleteLoader: any = null;
	pagetitle = "Appointment List";
	pageLoading = false;
	UserModuleAccess: any = "Full";
	hospitalList: any[] = [];
	doctorList: any[] = [];
	followUpStatusList: any[] = [];
	caseStatusList: any[] = [
		{ id: 1, name: "Open" },
		{ id: 2, name: "Closed" },
	];
	filters: any = {
		followup_status: null,
		case_status: null,
		case_category: null,
		from_date: null,
		to_date: null,
	};
	minDate = datePickerMinDate;
	isSCCase = isSCCase;
	allCaseCategories: any[] = [];
	caseExcelLoader = false;
	searchVal: any = null;
	user: any = null;
	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient) { }

	ngOnInit(): void {
		this.apiService.userData$.subscribe((user) => {
			if (user) {
				this.user = user;
				this.initDatatable();
				this.getAllFollowUpStatus();
				this.getCaseCatList();
			}
		})
	}

	ngOnDestroy(): void {

	}

	ngAfterViewInit(): void {

	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			layout: {
				topStart: ['pageLength'],
				topEnd: ['search'],
				bottomStart: ['info'],
				bottomEnd: ['paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				this.searchVal = dataTablesParameters.search.value;
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					searchVal: dataTablesParameters.search.value,
					usertype: this.user.usertype,
					...this.getAdvancedSearch()
				}
				this.apiService.getCase(data).subscribe({
					next: (response: any) => {
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						if (error.status == 404) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	getAdvancedSearch() {
		let data: any = {
			company: this.user.company
		};
		if (this.filters.followup_status) {
			data["followup_status"] = this.filters.followup_status;
		}
		if (this.filters.case_status) {
			data["case_status"] = this.filters.case_status;
		}
		if (this.filters.case_category) {
			data["case_category"] = this.filters.case_category;
		}
		if (this.filters.from_date) {
			data["from_date"] = this.apiService.getDateStringFromDate(this.filters.from_date);
		}
		if (this.filters.to_date) {
			data["to_date"] = this.apiService.getDateStringFromDate(this.filters.to_date);
		}
		return data;
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	getAllFollowUpStatus() {
		this.apiService.getAllFollowUpStatus().subscribe({
			next: (data: any) => {
				let groupedData = data.data.reduce((prev: any, current: any) => {
					const key = current.category;
					if (!prev[key]) {
						prev[key] = [];
					}
					prev[key].push(current);
					return prev;
				}, {});
				this.followUpStatusList = groupedData.FollowUp;
			}, error: (error) => {
				this.followUpStatusList = [];
			},
		});
	}

	getCaseCatList() {
		this.apiService.getAllCaseCategories().subscribe({
			next: (data: any) => {
				this.allCaseCategories = [{ id: "unassigned", name: "Unassigned" }, ...data];
			}, error: (error) => {
				this.allCaseCategories = [];
			},
		});
	}

	getExcel() {
		let payload: any = {
			...this.getAdvancedSearch()
		}
		if (this.searchVal) {
			payload["searchVal"] = this.searchVal;
		}
		this.caseExcelLoader = true;
		this.apiService.getCompanyCasesExcel(payload).subscribe({
			next: res => {
				let excelData: any = res.body;
				this.caseExcelLoader = false;
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let fileName = "Shorecare-Cases.xlsx";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.caseExcelLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}
}
